import React, { useContext } from 'react';
import { MainContext } from '../../context/Main.context';
import { LicenceTypes } from '../../utils/LicenceTypes';
import { PracticeTypes } from '../../utils/PracticeTypes';
import { Ellispis } from '../MorphoTab/MorphoTab.styled';
import { Tab } from '../Tab/Tab';
import { ButtonChoice, ButtonChoiceWrapper } from '../Tab/Tab.styled';

export const LicenceTypeTab = () => {
    const { 
        currentFormTab,
        licenceType,
        practice,
        setLicenceType,
        setPractice,
    } = useContext(MainContext);

    return (
        <Tab show={currentFormTab === 0}>
            <h2>Je souhaite prendre une licence</h2>
            <ButtonChoiceWrapper>
                <ButtonChoice
                    isActive={licenceType === LicenceTypes.ADULT}
                    type="button"
                    onClick={() => setLicenceType(LicenceTypes.ADULT)}
                >
                    Majeur
                </ButtonChoice>
                <ButtonChoice
                    isActive={licenceType === LicenceTypes.YOUNG}
                    type="button"
                    onClick={() => setLicenceType(LicenceTypes.YOUNG)}
                >
                    Mineur
                </ButtonChoice>
            </ButtonChoiceWrapper>
            <Ellispis>Choisissez une option</Ellispis>
            {licenceType === LicenceTypes.ADULT && (
                <>
                    <h2>Pratique souhaitée</h2>
                    <ButtonChoiceWrapper>
                        <ButtonChoice
                            isActive={practice === PracticeTypes.COMPET}
                            type="button"
                            onClick={() => setPractice(PracticeTypes.COMPET)}
                        >
                            Compétition
                        </ButtonChoice>
                        <ButtonChoice
                            isActive={practice === PracticeTypes.CASUAL}
                            type="button"
                            onClick={() => setPractice(PracticeTypes.CASUAL)}
                        >
                            Loisir
                        </ButtonChoice>
                        <ButtonChoice
                            isActive={practice === PracticeTypes.HANDFIT}
                            type="button"
                            onClick={() => setPractice(PracticeTypes.HANDFIT)}
                        >
                            HandFit
                        </ButtonChoice>
                        <ButtonChoice
                            isActive={practice === PracticeTypes.DIRIGEANT}
                            type="button"
                            onClick={() => setPractice(PracticeTypes.DIRIGEANT)}
                        >
                            Dirigeant
                        </ButtonChoice>
                    </ButtonChoiceWrapper>
                </>
            )}
        </Tab>
    );
}
